import "./App.css";
import Header from "./component/layout/header";

import Footer from "./component/layout/footer";
import MainSection from "./component/main-section";
import { Helmet } from "react-helmet";

function App() {
  return (
    <div className="App">
      <Helmet>
        <script src="assets/js/main.js" type="text/javascript" />
        <title>Progress Solution</title>
        <meta name="description" content="We are providing Laptop chip level service" />
      </Helmet>
      <Header />
      <MainSection />
      <Footer />
      <a
        href="#"
        class="back-to-top d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-arrow-up-short"></i>
      </a>
    </div>
  );
}

export default App;
